module.exports = __webpack_public_path__ + "img/ringProfile.96814d7.webp";